import * as React from "react";

const useTaskSelectorClassNameObserver = () => {
    const controllerRef = React.useRef<HTMLDivElement>(null);
    const [menuOpen, setMenuOpen] = React.useState(false);

    const handleOpenMenuMutation = (mutationsList: MutationRecord[]) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes"
                && mutation.attributeName === "class"
                && controllerRef.current?.classList.contains("menu-open")) {
                setMenuOpen(true);
            }
        }
    };

    React.useEffect(() => {
        if (!controllerRef.current) {
            return;
        }

        const targetNode = controllerRef.current;
        const observer = new MutationObserver(handleOpenMenuMutation);

        // Observe the target element for attribute changes
        observer.observe(targetNode, { attributes: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    return {
        menuOpen,
        setMenuOpen,
        controllerRef
    }
}

export default useTaskSelectorClassNameObserver;